/**
 * Rótulo de risco (o losango) por classe/subclasse, conforme o modelo da ONU
 * (Recomendações para o Transporte de Produtos Perigosos, cap. 5.2) adotado
 * na regulamentação brasileira.
 *
 * Só as classes que aparecem no catálogo de ensino e as mais comuns na
 * rodovia; o desenho 3D usa estas cores e o pictograma indicado.
 */

export type Pictograma = 'chama' | 'cilindro' | 'caveira' | 'chamaSobreCirculo' | 'corrosao' | 'explosao' | 'trifolio' | 'listras'

export interface AparenciaRotulo {
  classe: string
  nome: string
  /** Cor da metade de cima (ou do rótulo inteiro). */
  corSuperior: string
  /** Cor da metade de baixo; igual à de cima quando o rótulo é de uma cor só. */
  corInferior: string
  corSimbolo: string
  pictograma: Pictograma
}

const VERMELHO = '#d7261e'
const BRANCO = '#ffffff'
const PRETO = '#111111'
const AMARELO = '#f6c400'
const VERDE = '#1f8a3a'
const LARANJA = '#f08a00'

const ROTULOS: readonly AparenciaRotulo[] = [
  { classe: '1', nome: 'Explosivos', corSuperior: LARANJA, corInferior: LARANJA, corSimbolo: PRETO, pictograma: 'explosao' },
  { classe: '2.1', nome: 'Gases inflamáveis', corSuperior: VERMELHO, corInferior: VERMELHO, corSimbolo: PRETO, pictograma: 'chama' },
  { classe: '2.2', nome: 'Gases não inflamáveis, não tóxicos', corSuperior: VERDE, corInferior: VERDE, corSimbolo: PRETO, pictograma: 'cilindro' },
  { classe: '2.3', nome: 'Gases tóxicos', corSuperior: BRANCO, corInferior: BRANCO, corSimbolo: PRETO, pictograma: 'caveira' },
  { classe: '3', nome: 'Líquidos inflamáveis', corSuperior: VERMELHO, corInferior: VERMELHO, corSimbolo: PRETO, pictograma: 'chama' },
  { classe: '4.1', nome: 'Sólidos inflamáveis', corSuperior: BRANCO, corInferior: BRANCO, corSimbolo: PRETO, pictograma: 'listras' },
  { classe: '5.1', nome: 'Substâncias oxidantes', corSuperior: AMARELO, corInferior: AMARELO, corSimbolo: PRETO, pictograma: 'chamaSobreCirculo' },
  { classe: '6.1', nome: 'Substâncias tóxicas', corSuperior: BRANCO, corInferior: BRANCO, corSimbolo: PRETO, pictograma: 'caveira' },
  { classe: '7', nome: 'Material radioativo', corSuperior: AMARELO, corInferior: BRANCO, corSimbolo: PRETO, pictograma: 'trifolio' },
  { classe: '8', nome: 'Substâncias corrosivas', corSuperior: BRANCO, corInferior: PRETO, corSimbolo: PRETO, pictograma: 'corrosao' },
]

export function aparenciaRotulo(classe: string): AparenciaRotulo {
  const exato = ROTULOS.find((r) => r.classe === classe)
  // Sem herdar da classe: subclasses têm rótulos diferentes (6.2 é infectante, não caveira).
  if (exato) return exato
  throw new Error(`Classe de risco sem rótulo cadastrado: ${classe}`)
}

/** Número que vai no canto de baixo do rótulo: a classe (o "2" de 2.1, por exemplo). */
export const numeroNoRotulo = (classe: string): string => classe.split('.')[0]!
